import React from "react";
import ui from "../../pages/dashboard/DashboardUI.module.css";

export default function SettingsToggle({ columns, toggleColumn, refEl }) {
  return (
    <div className={ui.settingsPopover} ref={refEl}>
      {columns.map(({ key, label, visible }) => (
        <div key={key} className={ui.settingsOption}>
          <label>
            <input
              type="checkbox"
              checked={visible}
              onChange={() => toggleColumn(key)}
            />
            {label}
          </label>
        </div>
      ))}
    </div>
  );
}
